module.exports = __webpack_public_path__ + "static/media/sasha-grey-win.1654842b.jpg";